import { useSession } from 'components/auth/useSession'
import { FilterTags } from 'components/filtertags'
import { TipoEstabelecimentoEnum } from 'graphql/types.generated'
import { useServerTime } from 'hooks/useServerTime'

import { ListaAtendimentoFilterModel } from './model'
import { getListaAtendimentoFilterTags } from './utils-listaAtendimentoFilter'

interface ListaAtendimentoFilterTagsProps {
  filtros: ListaAtendimentoFilterModel
}

export function ListaAtendimentoFilterTags(props: ListaAtendimentoFilterTagsProps) {
  const { filtros } = props

  const { getServerTimeNow } = useServerTime()
  const { tipoEstabelecimento } = useSession()

  const now = getServerTimeNow()
  const isUpa = tipoEstabelecimento === TipoEstabelecimentoEnum.UPA

  const filterTags = getListaAtendimentoFilterTags(filtros, now, isUpa)

  return (
    <div data-testid='ListaAtendimentoFilterTags'>
      <FilterTags tags={filterTags} wrap={false} />
    </div>
  )
}
